// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1hmKu","avatar":"style_avatar__2LJ5G","menuIcon":"style_menuIcon__1qhKl"};